import Policy from "./Policy";

export default function QuotePolicy() {
  return <Policy type="quote" />;
}
